import BlankLayout from 'components/layout/blank-layout.component';
import { Loading } from 'components/block/loading';
import { NormalizedRoute, Routes } from 'services/route';

export function normalizeRoutes(routes: Routes, basePath: string) {
  routes.forEach((route) => {
    const fullPath = (basePath + route.path).replace('//', '/');

    (route as NormalizedRoute).fullPath = fullPath;
    route.component = route.component || BlankLayout;
    route.fallback = route.fallback || Loading;

    if (route.redirectTo) {
      const redirectToPath = route.redirectTo[0] === '/' ? route.redirectTo : basePath + route.redirectTo;

      route.redirectTo = redirectToPath;
    }

    if (route.children) {
      route.children = normalizeRoutes(route.children, fullPath + '/');
    }
  });

  return routes as NormalizedRoute[];
}
